import { Chips } from 'primereact/chips';
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface IInput {
    label?: string,
    name: string,
    control: any,
    error?: string,
    maxLength?: number,
    required?: boolean,
    disabled?: boolean,
    placeholder?: string,
    separator?: string,
    column?: number
}

export const JVChips = (props: IInput) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}
            <Controller name={props.name} control={props.control} render={({ field, fieldState }) => (
                <Chips {...field} maxLength={props.maxLength} separator={props.separator}
                    disabled={props.disabled}
                    placeholder={props.placeholder}
                    className={classNames({ 'p-invalid': fieldState.invalid })} />
            )} />
            <small className="p-error" >{props.error}</small>
        </div>
    );
}